import { Entrada } from './entrada.model';

export class Carrito {
  entradas: {
    entrada: Entrada;
    descuentos: any[];
    cantidad: number;
  }[];
  fecha: string;
  horarios: any;
  horariosPrevios: any;
  entradasPrevias: any;
  hayDescuentoMotivo: boolean;
  cantidadTotal: number;
  precioFinal: number;
  precioBase: number;
  precioConDescuento: number;
  ivaTotal: number;
  precioTotal: number;
  precioPrepago: number;
  localizador: string;
  reservaPagada: string;
  reservaAgrupada: string;
  reserva: {};
  albaran: {};
  carrito: Carrito2;
  importeDescuento: number; //Yaribel 20210727 cliente mapfre VSTS 8370
  hayDescuento: boolean; //Yaribel 20210728 cliente mapfre VSTS 8370
  precioTotalSinDescuento: number; //Yaribel 20210728 cliente mapfre VSTS 8370
  descuentoClienteAsociadoDatos: {};
  importeDescuentoCliente: number; //Añadimos el calculo total del descuento de cliente

  constructor(
    entradas: { entrada: Entrada; descuentos: []; cantidad: number }[] = []
  ) {
    this.entradas = entradas;
    this.horarios = [];
    this.horariosPrevios = [];
    this.entradasPrevias = [];
    this.hayDescuentoMotivo = false;
    this.cantidadTotal = 0;
    this.precioBase = 0;
    this.precioConDescuento = 0;
    this.ivaTotal = 0;
    this.precioTotal = 0;
    this.precioPrepago = 0;
    this.albaran = null;
    this.importeDescuento = 0; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = false; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = 0; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = {}; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.importeDescuentoCliente = 0;
  }

  setCarritoModificacionValue(carrito: Carrito) {
    this.entradas = carrito.entradas;
    this.horarios = carrito.horarios;
    this.horariosPrevios = carrito.horariosPrevios;
    this.entradasPrevias = carrito.entradasPrevias;
    this.hayDescuentoMotivo = carrito.hayDescuentoMotivo;
    this.cantidadTotal = carrito.cantidadTotal;
    this.precioBase = carrito.precioBase;
    this.precioConDescuento = carrito.precioConDescuento;
    this.ivaTotal = carrito.ivaTotal;
    this.precioTotal = carrito.precioTotal;
    this.precioPrepago = carrito.precioPrepago;
    this.albaran = carrito.albaran;
    this.importeDescuento = carrito.importeDescuento; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = carrito.hayDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = carrito.precioTotalSinDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = carrito.descuentoClienteAsociadoDatos; //Yaribel 20210728 cliente mapfre VSTS 8370
  }

  setCarritoModificacionCarritoValue(carrito: Carrito2) {
    this.entradas = carrito.entradas;
    this.horarios = carrito.horarios;
    this.hayDescuentoMotivo = carrito.hayDescuentoMotivo;
    this.cantidadTotal = carrito.cantidadTotal;
    this.precioBase = carrito.precioBase;
    this.precioConDescuento = carrito.precioConDescuento;
    this.ivaTotal = carrito.ivaTotal;
    this.precioTotal = carrito.precioTotal;
    this.precioPrepago = carrito.precioPrepago;
    this.importeDescuento = carrito.importeDescuento; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = carrito.hayDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = carrito.precioTotalSinDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = carrito.descuentoClienteAsociadoDatos; //Yaribel 20210728 cliente mapfre VSTS 8370
  }

  isEmpty() {
    return this.entradas.length === 0 ? true : false;
  }

  getCantidadPorEntrada(entrada: Entrada) {
    if (this.existeEntrada(entrada)) {
      const cantidad = this.existeEntrada(entrada).cantidad;
      return cantidad;
    }
    return 0;
  }

  private modificarCantidad(entrada: any, nuevaCantidad: number) {
    const esEntradaAmigosThyssen = entrada.entrada.DNIAbonadosExt && entrada.entrada.DNIAbonadosExt !== '';
    entrada.cantidad = nuevaCantidad;
  }

  agregarEntrada(entrada: Entrada, devolucion?) {

    if (this.existeEntrada(entrada)) {
      const entradaExistente = this.existeEntrada(entrada);
      if (devolucion) {
        const cantidadAnterior = entradaExistente.cantidad;
        this.modificarCantidad(entradaExistente, entradaExistente.cantidad + +entrada.Cantidad);
        entrada.PromocionEntradas.forEach((element) => {
          this.existeEntrada(entrada).entrada.PromocionEntradas.push(element);
        });
      } else {
        const cantidadAnterior = entradaExistente.cantidad;
        this.modificarCantidad(entradaExistente, entradaExistente.cantidad + 1);
      }
      if (
        entrada.CaracteristicasEntrada &&
        entrada.CaracteristicasEntrada.length > 0 &&
        this.existeEntrada(entrada).cantidad >
          entrada.CaracteristicasEntrada.length
      ) {
        this.existeEntrada(entrada).entrada.CaracteristicasEntrada.push(
          entrada.CaracteristicasEntrada[0]
        );
      }
    } else {
      let cantidad = devolucion ? entrada.Cantidad : 1; // Yaribel 20210224 Añadimos variable cantidad para que meta una cantidad o meta el total de entradas que recibe si es devolucion
      
      this.entradas.push({
        entrada: entrada,
        descuentos: [],
        cantidad: +cantidad,
      }); // Yaribel 20210224 Cambiamios que meta una cantidad a que meta el total de entradas que recibe
    }

    this.recalcularTotales();
  }

  eliminarEntrada(entrada: Entrada, devolucion?) {
    if (!this.existeEntrada(entrada)) {
      return;
    }
    const miEntrada = this.existeEntrada(entrada);
    const cantidadSolicitada = Number.isFinite(+entrada.Cantidad) && +entrada.Cantidad > 0
      ? +entrada.Cantidad
      : 1;
    if (miEntrada.cantidad <= cantidadSolicitada) {
      //Yaribel 20210225 comprobamos la cantidad xq puede ser mas de una
      this.entradas = this.entradas.filter((e) => {
        //
        // ;
        //
        //   (e.entrada.TipoEntradaId === entrada.TipoEntradaId || e.entrada.TipoPromocionId === entrada.TipoPromocionId),
        //     e.entrada.noEditable === entrada.noEditable
        // );
        /* 
          e.entrada.idRecintoButaca !== entrada.idRecintoButaca,
          e.entrada.fechaAuditorio === entrada.fechaAuditorio,
          e.entrada.horaAuditorio === entrada.horaAuditorio
        );*/
        return (
          ((e.entrada.CategoriaId !== entrada.CategoriaId ||
            e.entrada.TipoEntradaId !== entrada.TipoEntradaId ||
            e.entrada.TipoPromocionId !== entrada.TipoPromocionId) &&
            e.entrada.noEditable === entrada.noEditable) ||
          (e.entrada.idRecintoButaca !== entrada.idRecintoButaca &&
            e.entrada.fechaAuditorio === entrada.fechaAuditorio &&
            e.entrada.horaAuditorio === entrada.horaAuditorio)
        );
      });
    } else {
      this.modificarCantidad(this.existeEntrada(entrada), this.existeEntrada(entrada).cantidad - cantidadSolicitada);
      if (devolucion) {
        entrada.PromocionEntradas.forEach((element) => {
          //
          //
          this.removeItemFromArr(
            this.existeEntrada(entrada).entrada.PromocionEntradas,
            element
          );
        });
      }
    }
    //

    this.recalcularTotales();
  }

  removeItemFromArr(arr, item) {
    const i = arr.indexOf(item);
    if (i !== -1) {
      arr.splice(i, 1);
    }
  }

  agregarEntradas(entrada: Entrada, cantidad: number) {

    if (this.existeEntrada(entrada)) {
      const entradaExistente = this.existeEntrada(entrada);
      this.modificarCantidad(entradaExistente, cantidad);
      /*
      
      if (cantidad > entrada.CaracteristicasEntrada.length) {
        this.existeEntrada(entrada).entrada.CaracteristicasEntrada.push(entrada.CaracteristicasEntrada);
      }*/
    } else {
      this.entradas.push({
        entrada: entrada,
        descuentos: [],
        cantidad: cantidad,
      });
    }

    this.recalcularTotales();
  }

  public resetearCarrito() {
    this.entradas = [];
    this.horarios = [];
    this.horariosPrevios = [];
    this.entradasPrevias = [];
    this.fecha = '';
    this.hayDescuentoMotivo = false;
    this.cantidadTotal = 0;
    this.precioTotal = 0;
    this.precioBase = 0;
    this.precioConDescuento = 0;
    this.precioPrepago = 0;
    this.ivaTotal = 0;
    this.localizador = '';
    this.reservaPagada = '';
    this.reservaAgrupada = '';
    this.carrito = null;
    this.reserva = {
      ClaveReserva: '',
      ReservaId: '',
    };
    this.albaran = {
      pkId: '',
      TPVId: '',
      NumAlbaran: '',
      MediosPago: [],
    };
    this.importeDescuento = 0; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = false; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = 0; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = {}; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.importeDescuentoCliente = 0;

  }

  public resetearCarritoDeLocalizador() {
    this.entradas = [];
    this.horarios = [];
    this.horariosPrevios = [];
    this.entradasPrevias = [];
    this.fecha = '';
    this.hayDescuentoMotivo = false;
    this.cantidadTotal = 0;
    this.precioTotal = 0;
    this.precioBase = 0;
    this.precioConDescuento = 0;
    this.precioPrepago = 0;
    this.ivaTotal = 0;
    this.reservaPagada = '';
    this.reservaAgrupada = '';
    this.importeDescuento = 0; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = false; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = 0; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = {}; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.importeDescuentoCliente = 0; //Yaribel 20221019 añadimos la variable para almacenar el descuento de los clientes registrados

  }

  public resetearHorariosCarrito() {
    this.horarios = [];
    this.horariosPrevios = [];
  }

  recalcularTotales() {
    this.purgarEntradasSinCantidad();
    this.cantidadTotal = this.calcularCantidadTotal();
    this.precioBase = this.calcularPrecioBase();
    this.precioConDescuento = this.calcularPrecioConDescuentos();
    this.ivaTotal = this.calcularIvaTotal();
    this.precioTotal = this.calcularPrecioTotal();
    this.importeDescuentoCliente = this.calcularTotalDescuentoCliente();
    //this.precioPrepago = this.calcularPrecioPrepago();
  }

  private purgarEntradasSinCantidad() {
    const hayEntradasAmigosThyssen = this.entradas.some(e => e.entrada.DNIAbonadosExt && e.entrada.DNIAbonadosExt !== '');
    

    const entradasAntes = this.entradas.length;
    const entradasAEliminar = this.entradas.filter((linea) => linea.cantidad === 0);
  

    this.entradas = this.entradas.filter((linea) => linea.cantidad !== 0);
    const entradasDespues = this.entradas.length;

  }

  private calcularPrecioConDescuentos() {
    let precioTotal = 0;
    
    this.entradas.forEach((linea, index) => {
      let precio;
      
      if (linea.entrada.TipoProducto === '2') {
        const esDevolucion = window.location.href.includes('devolucion') || 
                            window.location.href.includes('pago-devolucion');
        
        if (esDevolucion) {
          // CORRECCIÓN: Para devoluciones de promociones, usar PrecioUnidad del AlbaranItems
          if (linea.entrada.PrecioUnidad && linea.entrada.PrecioUnidad !== '0') {
            precio = Number.parseFloat(linea.entrada.PrecioUnidad.toString().replace(/,/, '.'));
          } else if (linea.entrada.ImporteTicket !== undefined && linea.entrada.ImporteTicket > 0) {
            precio = linea.entrada.ImporteTicket;
          } else {
            // Fallback: usar PrecioEnDivisaReferencia si está disponible
            precio = Number.parseFloat(linea.entrada.PrecioEnDivisaReferencia.toString().replace(/,/, '.'));
          }
        } else {
          if (linea.entrada.ImporteTicket !== undefined && linea.entrada.ImporteTicket > 0) {
            precio = linea.entrada.ImporteTicket;
          } else {
            precio = Number.parseFloat(linea.entrada.PrecioEnDivisaReferencia.toString().replace(/,/, '.'));
          }
        }
      } else {
        // precio = linea.entrada.PrecioEnDivisaReferencia || linea.entrada.PrecioUnidad || linea.entrada.PrecioTotal || '0'; ANTIGUO CALCULO
        const precioRef = parseFloat((linea.entrada.PrecioEnDivisaReferencia || linea.entrada.PrecioUnidad || linea.entrada.PrecioTotal || '0').toString().replace(/,/, '.'));
        const comision = parseFloat((linea.entrada.Comision || '0').toString().replace(/,/, '.'));
        const esDevolucion = typeof window !== 'undefined' && (window.location.href.includes('devolucion') || window.location.href.includes('pago-devolucion'));
        // En devolución el total a devolver es solo precio de referencia (sin sumar comisión de nuevo)
        precio = esDevolucion ? precioRef.toString() : (precioRef + comision).toString();
      }
      
      const precioNumerico = Number.parseFloat(precio.toString().replace(/,/, '.'));
      
      
      precioTotal = precioTotal + (precioNumerico * linea.cantidad);
    });
    
    const precioFinal = Number.parseFloat(
      (
        precioTotal - (this.importeDescuento ? this.importeDescuento : 0)
      ).toFixed(4)
    );
    
    
    return precioFinal;
  }

  private calcularPrecioBase() {
    let pBase = 0;
    this.entradas.forEach((linea) => {
      if (!linea.entrada.noEditable) {
        pBase =
          pBase +
          Number.parseFloat(linea.entrada.PrecioBase.replace(/,/, '.')) *
            linea.cantidad;
        //pBase = Math.round(pBase * 100) / 100;
      }
    });
    //
    return Number.parseFloat(pBase.toFixed(4));
  }

  private calcularIvaTotal() {
    let ivaTotal = 0;
    this.entradas.forEach((linea) => {
      if (!linea.entrada.noEditable) {
        // CORRECCIÓN: Validar que los campos existen antes de hacer replace
        const precioEnDivisaReferencia = linea.entrada.PrecioEnDivisaReferencia || '0';
        const precioBase = linea.entrada.PrecioBase || '0';
        const comision = linea.entrada.Comision || '0';
        
        ivaTotal =
          (Number.parseFloat(
            precioEnDivisaReferencia.replace(/,/, '.')
          ) -
            (Number.parseFloat(precioBase.replace(/,/, '.')) +
              Number.parseFloat(comision.replace(/,/, '.')))) *
            linea.cantidad;
      }
    });
    return Number.parseFloat(ivaTotal.toFixed(2));
    //return ivaTotal;
  }

  private calcularPrecioTotal() {
    return this.precioConDescuento;
  }

  private calcularTotalDescuentoCliente() {
    let precioTotal = 0;
    this.entradas.forEach((linea) => {
      precioTotal =
        precioTotal +
        Number.parseFloat(
          Number.parseFloat(
            (linea.entrada.ImporteDto || '0').replace(/,/, '.')
          ).toFixed(4)
        ) *
          linea.cantidad;
      //precioTotal = Math.round(precioTotal * 100) / 100;
    });
    return Number.parseFloat(precioTotal.toFixed(4));
    //return precioTotal;
  }

  private calcularPrecioPrepago() {
    let precioPrepago = 0;
    this.entradas.forEach((entrada) => {
      if (entrada.entrada.noEditable) {
        if (entrada.entrada.TipoProducto === '1') {
          precioPrepago =
            precioPrepago +
            Number.parseFloat(
              entrada.entrada.PrecioEnDivisaReferencia.replace(/,/, '.')
            ) *
              entrada.cantidad;
        } else if (entrada.entrada.TipoProducto === '2') {
          entrada.entrada.PromocionEntradas.forEach((item) => {
            precioPrepago =
              precioPrepago +
              Number.parseFloat(item.PrecioUnidad.replace(/,/, '.')) *
                entrada.cantidad *
                Number.parseFloat(item.NumeroEntradas);
          });
        }
      }
    });
    //
    return precioPrepago;
    /*     let pTotal = 0;
    this.entradas
      .filter(linea => linea.entrada.noEditable)
      .forEach(linea => {
        pBase =
          pBase +
          Number.parseFloat(linea.entrada.PrecioEnDivisaReferencia.replace(/,/, '.')) *
            linea.cantidad;
        pBase = Math.round(pBase * 100) / 100;
      });
    return pBase + ivaTotal; */
  }

  private calcularCantidadTotal() {
    let cantidadTotal = 0;
    this.entradas.forEach((linea) => {
      cantidadTotal = cantidadTotal + +linea.cantidad;
    });

    return cantidadTotal;
  }

  private existeEntrada(entrada: Entrada) {
    const hayEntradasEnCarrito = this.entradas.length > 0;
    const esEntradaAmigosThyssen = entrada.DNIAbonadosExt && entrada.DNIAbonadosExt !== '';
    const porReferencia = this.entradas.find((e) => e.entrada === entrada);
    if (porReferencia) {
      return porReferencia;
    }

    

    if (entrada.TipoProducto === '1') {
      
      const resultado = this.entradas.find(
        (e, index) => {          
          // Comparación TipoEntradaId
          const tipoEntradaMatch = e.entrada.TipoEntradaId === entrada.TipoEntradaId;
          
          // Comparación CategoriaId
          const categoriaMatch = e.entrada.CategoriaId === entrada.CategoriaId || 
                               (entrada.TipoProducto === '1' && !entrada.idRecintoButaca && !e.entrada.idRecintoButaca);
          
          // Comparación noEditable
          const noEditableMatch = (!entrada.noEditable || e.entrada.noEditable === entrada.noEditable);
          
          // Comparación idRecintoButaca
          const idRecintoMatch = (e.entrada.idRecintoButaca === entrada.idRecintoButaca || 
                                 (!e.entrada.idRecintoButaca && !entrada.idRecintoButaca));
          
          // Comparación fechaAuditorio
          const fechaAuditorioMatch = (e.entrada.fechaAuditorio === entrada.fechaAuditorio || 
                                     (!e.entrada.fechaAuditorio && !entrada.fechaAuditorio));
          
          // Comparación horaAuditorio
          const horaAuditorioMatch = (e.entrada.horaAuditorio === entrada.horaAuditorio || 
                                    (!e.entrada.horaAuditorio && !entrada.horaAuditorio));
          
          // Comparación DNIAbonadosExt
          const dniCarrito = String(e.entrada.DNIAbonadosExt || '');
          const dniBuscando = String(entrada.DNIAbonadosExt || '');
          const dniAbonadosMatch = (dniCarrito === dniBuscando || 
                                  (dniCarrito === '' && dniBuscando === ''));
          
          const idTarifaMatch =
            String(e.entrada.idTarifa ?? '') === String(entrada.idTarifa ?? '');

          // Resultado final
          const match =
            tipoEntradaMatch &&
            categoriaMatch &&
            noEditableMatch &&
            idRecintoMatch &&
            fechaAuditorioMatch &&
            horaAuditorioMatch &&
            dniAbonadosMatch &&
            idTarifaMatch;
          
          return match;
        }
      );
      
      return resultado;
    } else if (entrada.TipoProducto === '2') {
      const resultado = this.entradas.find(
        (e) => {
          const tipoPromocionMatch = e.entrada.TipoPromocionId === entrada.TipoPromocionId;
          const categoriaMatch = e.entrada.CategoriaId === entrada.CategoriaId || 
                               (entrada.TipoProducto === '2' && !entrada.idRecintoButaca && !e.entrada.idRecintoButaca);
          const noEditableMatch = (!entrada.noEditable || e.entrada.noEditable === entrada.noEditable);
          const idRecintoMatch = (e.entrada.idRecintoButaca === entrada.idRecintoButaca || 
                                 (!e.entrada.idRecintoButaca && !entrada.idRecintoButaca));
          const fechaAuditorioMatch = (e.entrada.fechaAuditorio === entrada.fechaAuditorio || 
                                     (!e.entrada.fechaAuditorio && !entrada.fechaAuditorio));
          const horaAuditorioMatch = (e.entrada.horaAuditorio === entrada.horaAuditorio || 
                                    (!e.entrada.horaAuditorio && !entrada.horaAuditorio));
          // Verificar que el DNIAbonadosExt coincida (importante para amigos thyssen)
          // Convertir a string para comparar, ya que puede venir como número o string
          const dniCarrito = String(e.entrada.DNIAbonadosExt || '');
          const dniBuscando = String(entrada.DNIAbonadosExt || '');
          const dniAbonadosMatch = (dniCarrito === dniBuscando || 
                                  (dniCarrito === '' && dniBuscando === ''));

          const idTarifaMatch =
            String(e.entrada.idTarifa ?? '') === String(entrada.idTarifa ?? '');

          const match =
            tipoPromocionMatch &&
            categoriaMatch &&
            noEditableMatch &&
            idRecintoMatch &&
            fechaAuditorioMatch &&
            horaAuditorioMatch &&
            dniAbonadosMatch &&
            idTarifaMatch;

          return match;
        }
      );
      
      return resultado;
    }
    return undefined;
  }

  getCaracteristicasxEntrada(entrada: Entrada) {
    if (this.existeEntrada(entrada)) {
      return this.existeEntrada(entrada).entrada.CaracteristicasEntrada;
    }
    return [];
  }
}
export class Carrito2 {
  entradas: {
    entrada: Entrada;
    descuentos: any[];
    cantidad: number;
  }[];
  fecha: string;
  horarios: any;
  hayDescuentoMotivo: boolean;
  cantidadTotal: number;
  precioFinal: number;
  precioBase: number;
  precioConDescuento: number;
  ivaTotal: number;
  precioTotal: number;
  precioPrepago: number;
  localizador: string;
  reserva: {};
  albaran: {};
  reservaPagada: string; //Yaribel 20210210 añadimos la variable para controlar que la reserva ya este pagada
  reservaAgrupada: string; //Yaribel 20210227 añadimos la variable para controlar que la reserva este agrupada
  importeDescuento: number; //Yaribel 20210727 cliente mapfre VSTS 8370
  hayDescuento: boolean; //Yaribel 20210728 cliente mapfre VSTS 8370
  precioTotalSinDescuento: number; //Yaribel 20210728 cliente mapfre VSTS 8370
  descuentoClienteAsociadoDatos: {}; //Yaribel 20210728 cliente mapfre VSTS 8370

  constructor(carrito: Carrito) {
    this.entradas = carrito.entradas;
    this.horarios = carrito.horarios;
    this.hayDescuentoMotivo = carrito.hayDescuentoMotivo;
    this.cantidadTotal = carrito.cantidadTotal;
    this.precioBase = carrito.precioBase;
    this.precioConDescuento = carrito.precioConDescuento;
    this.ivaTotal = carrito.ivaTotal;
    this.precioTotal = carrito.precioTotal;
    this.precioPrepago = carrito.precioPrepago;
    this.importeDescuento = carrito.importeDescuento; //Yaribel 20210727 cliente mapfre VSTS 8370
    this.hayDescuento = carrito.hayDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.precioTotalSinDescuento = carrito.precioTotalSinDescuento; //Yaribel 20210728 cliente mapfre VSTS 8370
    this.descuentoClienteAsociadoDatos = {}; //Yaribel 20210728 cliente mapfre VSTS 8370
  }
}
